var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex lh-1" }, [
    _vm.data
      ? _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.tooltip,
                expression: "tooltip",
              },
            ],
            staticClass:
              "avatar avatar-name avatar-sm avatar-assigned-by text-white rounded-circle",
            class: _vm.userAvatar(_vm.data && _vm.data.user).bg,
            attrs: {
              "data-target": "offcanvasFrom",
              "data-offcanvasfrom": "offcanvas",
              "data-role-id": "1",
              "data-role-name": "OWNER",
              href: "javascript:void(0)",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("click")
              },
            },
          },
          [
            !_vm.userAvatar(_vm.data && _vm.data.user).hasImage
              ? _c("span", { staticClass: "text-md" }, [
                  _vm._v(
                    _vm._s(_vm.userAvatar(_vm.data && _vm.data.user).avatar)
                  ),
                ])
              : _vm._e(),
            _vm.userAvatar(_vm.data && _vm.data.user).hasImage
              ? _c("img", {
                  attrs: {
                    alt: "Image placeholder",
                    src: _vm.userAvatar(_vm.data && _vm.data.user).avatar,
                  },
                })
              : _vm._e(),
          ]
        )
      : _vm._e(),
    !_vm.data && _vm.disableEdit != true
      ? _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.top-center",
                value: _vm.title || `Add new user`,
                expression: "title || `Add new user`",
                modifiers: { "top-center": true },
              },
            ],
            staticClass: "to-3 avatar avatar--38 rounded-circle",
            attrs: {
              href: "javascript:void(0)",
              "data-target": "offcanvascced_int",
              "data-offcanvasfrom": "offcanvas",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("click")
              },
            },
          },
          [_c("i", { staticClass: "fas fa-plus text-xs" })]
        )
      : _vm._e(),
    !_vm.data && _vm.disableEdit == true
      ? _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.top-center",
                value: _vm.title || `No User Assigned`,
                expression: "title || `No User Assigned`",
                modifiers: { "top-center": true },
              },
            ],
            staticClass: "to-3 avatar avatar--38 rounded-circle",
            attrs: {
              href: "javascript:void(0)",
              "data-target": "offcanvascced_int",
              "data-offcanvasfrom": "offcanvas",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("click")
              },
            },
          },
          [_c("i", { staticClass: "fas fa-user text-md" })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }